import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Cargar config.json antes de renderizar para que API_BASE_URL esté disponible
fetch(`${process.env.PUBLIC_URL}/config.json`)
  .then(r => r.json())
  .then(config => { window._appConfig = config; })
  .catch(() => { window._appConfig = null; })
  .finally(() => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    reportWebVitals();
  });
